import { UiLoginContainerModel } from "../../models";

export function mockUiLoginContainerModel({
    id = "login-container-1234",
    type = "uiLoginContainer",
    locale = "en",
    content = mockUiLoginContainerModelContent()
}: Partial<UiLoginContainerModel> = {}): UiLoginContainerModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiLoginContainerModelContent = UiLoginContainerModel["content"];

export function mockUiLoginContainerModelContent({
    title = "Example login container",
    ...optionals
}: Partial<UiLoginContainerModelContent> = {}): UiLoginContainerModelContent {
    return {
        title,
        ...optionals
    };
}
